import React, { useEffect, useMemo, useRef, useState } from "react";
import ModalSelector from "../../../components/form/ModalSelector";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { createDynamicColumnsFromObject } from "../../../utils/grid";
import { toast } from "react-toastify";
import api from "../../../utils/axios";
import { ColDef } from "ag-grid-community";
import { Button } from "antd";
import RaportDinamikForm from "./RaportDinamikForm";
import dayjs from "dayjs";

export const isNullOrWhiteSpace = (value: any) =>
	!value?.toString()?.trim()?.length;
interface ReportDefinition {
	id: number;
	pershkrimi: string;
	parametrat: string;
}

interface ParameterConfig {
	required: boolean;
	id: number;
	type: string;
	value: any;
}

interface SubmitData {
	[key: string]: ParameterConfig;
}

interface DynamicReportRowData {
	[key: string]: any;
}

type DynamicReport = {
	id: number;
	procedureName: string;
	description?: string | null;
	procedureParameters?: string | null;
};

// Example of a custom endpoint fetch (just a demonstration)

const getDynamicReportsTable = async ({
	data,
	id,
}: {
	data: string | null;
	id: number;
}): Promise<DynamicReportRowData[]> => {
	const response = await api.post("DynamicReport", {
		id: id,
		data: data,
	});
	return response.data;
};

const DynamicReport = () => {
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			autoHeight: true,
			filterParams: { excelMode: "windows" },
			enablePivot: true,
			enableRowGroup: true,
			enableValue: true,
			sideBar: true,
		}),
		[]
	);

	const statusBar = useMemo(
		() => ({
			statusPanels: [
				{
					statusPanel: "agAggregationComponent",
					statusPanelParams: {
						// possible values are: 'count', 'sum', 'min', 'max', 'avg'
						aggFuncs: ["avg", "sum", "avg", "count"],
					},
				},
			],
		}),
		[]
	);

	const [submitData, setSubmitData] = useState<any>(null);
	const [selectedRow, setSelectedRow] = useState<any>(null);
	const [columnDefs, setColumnDefs] = useState<ColDef[]>();
	const [fullPage, setFullPage] = useState<boolean>(false);
	const [dataTable, setDataTable] = useState<any>([]);
	const gridRef = useRef<AgGridReact | null>(null);
	const [raportetData, setRaportetData] = useState<DynamicReport[]>([]);
	const [deliveredOrders, setDeliveredOrders] = useState<any>([]);

	const getDynamicReports = async () => {
		try {
			const response = await api.get(
				"DynamicReport/select-dynamic-reports"
			);
			if (response.status === 200) {
				setRaportetData(response?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getOrders = async () => {
		try {
			const fileName = "Porosite-KS-01-31.10.24.xlsx";

			const response = await api.post(
				"DynamicReport/select-orders",
				{},
				{
					headers: {
						"Content-Type": "application/json",
					},
					responseType: "blob",
				}
			);
			const blob = new Blob([response.data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			const fileURL = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			// const orders = response.data;
			// setDeliveredOrders(orders);
		} catch (error) {
			console.error(error);
			toast.error("Failed to fetch orders");
		}
	};

	useEffect(() => {
		getDynamicReports();
	}, []);

	const handleProcedureSelect = (data: any) => {
		setDataTable([]);
		setSelectedRow(data);
		if (!(data?.procedureParameters?.trim().length > 0)) {
			setSubmitData(null);
			return;
		}
		const parameters = data.procedureParameters.split(",");

		// converts from array into object
		const submitData = parameters.reduce((acc: any, val: any) => {
			if (val.toString().length > 1) {
				let parameter = val.trim().split(" ");
				let parameterName = parameter[0]?.trim();
				let parameterType = parameter[1]?.trim()?.toLowerCase();
				let required = !(parameter[2] === "null");
				let parameterValue = null;
				if (
					(parameterType === "bool" || parameterType === "bit") &&
					required
				) {
					parameterValue = false; // false when bool and required
				} else if (
					parameterType === "date" ||
					parameterType === "datetime"
				) {
					parameterValue = null;
				}
				return {
					...acc,
					[parameterName]: {
						required,
						id: data.id,
						type: parameterType,
						value: parameterValue,
					},
				};
			}
		}, {});
		console.log(submitData, "submitData");
		setSubmitData(submitData);
		// clears form inputs
	};

	const normalizeSubmitData = (data: SubmitData | null) => {
		if (!data) return null;

		return Object.entries(data).reduce((acc, [key, config]) => {
			if (config.type !== "date" && config.type !== "datetime") {
				acc[key] = config;
				return acc;
			}

			const normalizedValue =
				typeof config.value === "string"
					? config.value
					: config.value
					? dayjs(config.value).format(
							config.type === "datetime"
								? "YYYY-MM-DD HH:mm:ss"
								: "YYYY-MM-DD"
					  )
					: null;

			acc[key] = {
				...config,
				value: normalizedValue,
			};

			return acc;
		}, {} as SubmitData);
	};

	const postData = async (
		submitData: SubmitData | null,
		selectedRow: ReportDefinition
	) => {
		try {
			// const payload = submitData ? JSON.stringify(submitData) : null;
			const payload = submitData
				? JSON.stringify(normalizeSubmitData(submitData))
				: null;

			const data = {
				data: payload,
				id: selectedRow.id,
			};
			const result = await getDynamicReportsTable({
				data: payload,
				id: selectedRow.id,
			});

			if (!result?.length) {
				toast.info("No data found!");
				setColumnDefs([]);
				setDataTable([]);
				setFullPage(false);
				return;
			}

			const columns = createDynamicColumnsFromObject(result[0]);
			setColumnDefs(columns);
			setDataTable(result);
			setFullPage(true);
		} catch (err) {
			console.error(err);
			toast.error("Error while processing report!");
		}
	};

	const onSubmit = async (submitData: any) => {
		if (!selectedRow) {
			toast.error("Stored procedure is required");
			return;
		}
		(gridRef.current as any)?.api.setFilterModel(null);
		if (!submitData) {
			await postData(null, selectedRow);
			return;
		}
		const submitDataEntries = Object.entries(submitData);
		for (let i = 0; i < submitDataEntries.length; i++) {
			const valueKeyPair = submitDataEntries[i];
			const paramName = valueKeyPair[0];
			const data: any = valueKeyPair[1];
			if (data?.required && isNullOrWhiteSpace(data?.value)) {
				toast.warning(`${paramName} is required`);
				return;
			}
		}
		await postData(submitData, selectedRow);
	};

	const handleRowDelete = () => {
		setSubmitData(null);
		setDataTable([]);
		setSelectedRow(null);
	};

	useEffect(() => {
		return () => {
			setDataTable([]);
		};
	}, []);

	return (
		<>
			<title>{"Dynamic report"}</title>
			<div>
				<div className={`${fullPage ? "flex flex-row gap-12" : ""} `}>
					<ModalSelector
						tableData={raportetData}
						columnsToShow={["description"]}
						columnToSearch={"id"}
						buttonLabel="Procedura"
						onRowSelected={(data) => handleProcedureSelect(data)}
						onRowDeleted={handleRowDelete}
					/>
					<RaportDinamikForm
						key={selectedRow?.id}
						selectedRow={selectedRow}
						defaultInputValues={submitData}
						onSubmit={onSubmit}
						fullPage={fullPage}
					/>
				</div>
				{!!dataTable?.length && (
					<div
						className="ag-theme-alpine grid-container mt-3"
						style={{
							height: 550,
							minHeight: 400,
						}}
					>
						<AgGridReact
							defaultColDef={defaultColDef}
							pivotMode={false}
							pivotPanelShow="always"
							columnDefs={columnDefs}
							rowData={dataTable}
							enterMovesDown={true}
							statusBar={statusBar}
							sideBar={true}
							rowSelection="single"
							enableRangeSelection={true}
							suppressCopyRowsToClipboard={true}
							ref={gridRef}
							rowHeight={46}
							headerHeight={50}
							pagination
							paginationPageSize={200}
						/>
					</div>
				)}
			</div>
		</>
	);
};

export default DynamicReport;
